import { sendAnonymousSupportMessage, sendSupportMessage } from "@/api/openapi";
import { PspContext } from "@/config/contexts";
import { useIsTablet } from "@/config/hooks";
import { translate } from "@/config/translator";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export function useHelp() {
  const navigate = useNavigate();
  const { user, lang } = useContext(PspContext);
  const isLoggedIn = !!user;
  const isTablet = useIsTablet();

  const [email, setEmail] = useState(isLoggedIn ? user.email : "");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  const canSend = email && subject && body;

  function onSend() {
    if (!canSend) return;

    if (isLoggedIn) {
      sendSupportMessage({
        body: {
          email: user.email,
          body,
          subject,
        },
      }).then(({ error }) => {
        if (error) {
          toast(translate("somethingWentWrong", lang));
        } else {
          toast(translate("messageSentSuccessfully", lang));
          setSubject("");
          setBody("");
          navigate("/home");
        }
      });
    } else {
      sendAnonymousSupportMessage({
        body: {
          email,
          body,
          subject,
        },
      }).then(({ error }) => {
        if (error) {
          toast(translate("somethingWentWrong", lang));
        } else {
          toast(translate("messageSentSuccessfully", lang));
          setEmail("");
          setSubject("");
          setBody("");
          navigate("/login");
        }
      });
    }
  }

  return {
    email,
    setEmail,
    body,
    setBody,
    isLoggedIn,
    subject,
    setSubject,
    onSend,
    lang,
    navigate,
    canSend,
    isTablet,
  };
}
